var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AbfragerQuestionComment_1;
import React from 'react';
import { observer } from 'mobx-react';
import { Aspect_ } from '../../../../components/actor/Aspect_';
import { CommentType } from '../../../../classes/learnware/LearnwareEnums';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
let AbfragerQuestionComment = AbfragerQuestionComment_1 = class AbfragerQuestionComment extends React.PureComponent {
    get shouldShowComment() {
        const { question, commentType } = this.props;
        if (question.context.app.appInfo.isUserCurrentlyEditing && this.commentAspect.aspectContent.local.hasContent) {
            return true;
        }
        if (!question.answeringState.isCompletlyAnswered)
            return false;
        if (commentType === CommentType.CommentCorrect && !question.answeringInfo.isFullyCorrect)
            return false;
        if (commentType === CommentType.CommentWrong && !question.answeringInfo.isAtLeastPartiallyWrong)
            return false;
        if (!this.commentAspect.aspectContent.local.hasContent)
            return false;
        return true;
    }
    get commentAspect() {
        return this.props.question.ownAspect[this.props.commentType];
    }
    render() {
        const { question } = this.props;
        if (!this.shouldShowComment) {
            return null;
        }
        return (React.createElement("div", { style: { flex: '1 1 auto', display: 'flex', alignItems: 'center', flexDirection: 'column' } },
            React.createElement(Aspect_, { aspect: this.commentAspect, templateComponent: AbfragerQuestionComment_1.templateComponent })));
    }
    static get templateComponent() {
        return (React.createElement("div", { style: {
                marginTop: 25,
                width: '90%',
                padding: 20,
                margin: '20px 0',
                border: '1px solid #eee',
                borderLeftWidth: 5,
                borderRadius: 3,
                borderLeftColor: '#a5c956',
                color: '#333',
            } }));
    }
};
__decorate([
    memoize
], AbfragerQuestionComment, "templateComponent", null);
AbfragerQuestionComment = AbfragerQuestionComment_1 = __decorate([
    observer
], AbfragerQuestionComment);
export { AbfragerQuestionComment };
